function initialiseStatusAppStyles() {
  function applyStyles() {
    const root = document.querySelector('#status-app')?.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('style[data-elk-status-app]')) {
      const style = document.createElement('style');
      style.dataset.elkStatusApp = '';
      style.textContent =
        '@media screen and (max-width: 749px) { .me-button { font-size:10px!important; } .me-button svg { width:16px!important; height:16px!important;} }';
      root.appendChild(style);
    }
    return true;
  }
  if (applyStyles()) return;
  const observer = new MutationObserver(() => {
    if (applyStyles()) observer.disconnect();
  });
  observer.observe(document.body, {childList: true, subtree: true});
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseStatusAppStyles, {once: true});
} else {
  initialiseStatusAppStyles();
}
